import Vue from 'vue'
import selectExpert from './selectExpertDialog.vue'

let selectExpertConstructor = Vue.extend(selectExpert)
let instance

const selectTip = function(options = {}) {
  instance = new selectExpertConstructor({
    data: options
  })
  document.body.appendChild(instance.$mount().$el)
}

// export default importTip
export default {
  install (Vue, options) {
    Vue.prototype.$selectExpert = selectTip
  }
}



// WEBPACK FOOTER //
// ./src/components/selectExpert/selectExpert.js